module.exports = __webpack_public_path__ + "html/handover.template.html";